import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';
import { DigestQueryParam } from '@front-app/modules/digests/routing/params';

export const notificationsAndDigests: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('admin-tabs.notifications-and-digests') as string;
			},
		},
		path: 'notifications-and-digests',
		name: Routes.GROUP_ADMIN_NOTIFICATIONS_AND_DIGESTS,
		redirect: { name: Routes.GROUP_ADMIN_NOTIFICATION_SETTINGS },
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				groupId: route.params.groupId,
			};
		},
		component: () => import(
			/* webpackChunkName: "group-admin-notifications-and-digests" */
			'@front-app/views/home/group/admin/notificationsAndDigests/NotificationsAndDigests.vue'
		),
		children: [
			{
				meta: {
					title(i18n: VueI18n): string {
						// TODO: Add group title here as well, somehow
						return i18n.t('admin-tabs.notification-settings') as string;
					},
				},
				path: 'notification-settings',
				name: Routes.GROUP_ADMIN_NOTIFICATION_SETTINGS,
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						groupId: route.params.groupId,
					};
				},
				component: () => import(
					/* webpackChunkName: "group-admin-notification-settings" */
					'@front-app/views/home/group/admin/notificationsAndDigests/NotificationSettings.vue'
				),
			},
			{
				meta: {
					title(i18n: VueI18n): string {
						// TODO: Add group title here as well, somehow
						return i18n.t('admin-tabs.digest-management') as string;
					},
				},
				path: 'digests',
				name: Routes.GROUP_ADMIN_DIGESTS,
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						groupId: route.params.groupId,
						digestIdToEdit: route.query[DigestQueryParam.EDIT],
					};
				},
				component: () => import(
					/* webpackChunkName: "group-admin-digests" */
					'@front-app/views/home/group/admin/notificationsAndDigests/Digests.vue'
				),
			},
		],
	},
];
